import type { FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import type { Image, Lesson } from '@segment/api/routes/academy/types'

import LessonCard from './LessonCard'

import data from './data'

const copy = {
  heading: `A preview of what you’ll learn from our courses`,
  description: `Our handcrafted courses include basics of analytics as well as more advanced processes and strategies, to help your business grow faster.`,
}

export interface FeaturedLesson
  extends Pick<Lesson, `url` | `description` | `title` | `lessonNumber` | `courseNumber` | `courseTitle`> {
  numberOfLessons: number
  courseIcon: Image
}

const FeaturedLessons: FC = () => {
  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <StyledCopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </StyledCopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <ColumnTrack
          overrides={{
            lg: 3,
          }}
        >
          {data.map((lesson, key) => (
            <LessonCard key={key} lesson={lesson} />
          ))}
        </ColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 684px;
  margin: 0 auto;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    text-align: center;
  }
`

export default FeaturedLessons
